var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"ls-img-dialog-component"},[_c('div',{staticClass:"dialog-content"},[_c('img',{staticClass:"close-img",attrs:{"src":"https://cdnws.51tyty.com/lstyty/file/2023/03/15/7d04d6daf01f5b6dd4b70eb1c8dc7dae.png","alt":""},on:{"click":_vm.cancel}}),_vm._t("content",function(){return [_vm._v("默认内容")]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }